import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { EpdDocumentKind, EpdState } from '@app/models/orders';

export const useEpdStateName = (kind?: EpdDocumentKind) => {
  const epdT = useTranslation(NSKeys.epd);
  return (state: EpdState) =>
    kind && state === EpdState.Completed
      ? epdT.t(`completedDocuments.${kind}` as const)
      : epdT.t(`states.${state}` as const);
};
